import { createContext } from 'react';
import { MakerSchema } from 'src/models/maker/schema';

export const MakersContext = createContext<MakerSchema[]>([]);
